export default "__VITE_ASSET__DJI9TiuS__"